import { httpDelete, httpGet, httpPatch, httpPost } from "../connection";

export async function getCaseProgress() {
  return await httpGet(`/case-progress`);
}

export async function createCaseProgress(values: { progress_name: string }) {
  return await httpPost(`/case-progress`, values);
}

export async function updateCaseProgress(
  progress_id: number,
  values: { progress_name?: string; progress_order?: number } = {}
) {
  return await httpPatch(`/case-progress/${progress_id}`, values);
}

export async function deleteCaseProgress(
  id: number,
  options = { replace: null }
) {
  if (options.replace == null) return await httpDelete(`/case-progress/${id}`);
  else if (options.replace != null)
    return await httpDelete(`/case-progress/${id}?replace=${options.replace}`);
}

const CaseProgressApi = {
  getCaseProgress,
  createCaseProgress,
  updateCaseProgress,
  deleteCaseProgress,
};

export default CaseProgressApi;
